module.exports = __webpack_public_path__ + "img/icon.3e139fb8.jpg";